import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-ef5488b6")

_pushScopeId("data-v-ef5488b6")
const _hoisted_1 = { class: "root" }
const _hoisted_2 = /*#__PURE__*/_createVNode("h2", null, "Applications", -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("p", null, "Here are my current applictions", -1)
const _hoisted_4 = { class: "appCardBody" }
const _hoisted_5 = {
  key: 0,
  class: "construction"
}
const _hoisted_6 = /*#__PURE__*/_createVNode("span", { class: "constructionText" }, " APP UNDER CONSTRUCTION ", -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_AppCard = _resolveComponent("AppCard")
  const _component_AppGrid = _resolveComponent("AppGrid")
  const _component_Navigation = _resolveComponent("Navigation")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_Navigation, null, {
      default: _withId(() => [
        _hoisted_2,
        _hoisted_3,
        _createVNode(_component_AppGrid, null, {
          default: _withId(() => [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.Applications, ({appName, description, isUnderConstruction}, appKey) => {
              return (_openBlock(), _createBlock(_component_AppCard, {
                key: `application-list-${appKey}`,
                to: _ctx.generateDynamicPath(_ctx.Paths.APPLICATIONS, appKey),
                className: "appCard"
              }, {
                default: _withId(() => [
                  _createVNode("div", _hoisted_4, [
                    _createVNode("h2", null, _toDisplayString(appName), 1),
                    _createVNode("p", null, _toDisplayString(description), 1),
                    isUnderConstruction
                      ? (_openBlock(), _createBlock("div", _hoisted_5, [
                          _hoisted_6
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _: 2
              }, 1032, ["to"]))
            }), 128))
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
})